import React from "react";
import "./termspolicy.scss";
import { PublicService } from "../../services";
import { useQuery } from "@tanstack/react-query";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer";
import { Helmet } from "react-helmet";

const Terms = () => {
  const { getTermsApi } = PublicService();

  const terms = useQuery({
    queryKey: ["privacy"],
    queryFn: () => getTermsApi(),
  });

  return (
    <>
      <Helmet defer={false}>
        <title>Terms & Conditions | Holypills Healthcare Services</title>
        <meta
          name="description"
          content="Review Holypills Terms & Conditions to learn about user responsibilities, platform usage, and service guidelines."
        />
        <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />
        <link rel="canonical" href="https://holypills.in/terms" />

        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Terms & Conditions | Holypills Healthcare Services"
        />
        <meta
          property="og:description"
          content="Review Holypills Terms & Conditions to learn about user responsibilities, platform usage, and service guidelines."
        />

        <meta property="og:url" content="https://holypills.in/terms" />
        <meta property="og:site_name" content="Holypills"></meta>

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Terms & Conditions | Holypills Healthcare Services"
        />
        <meta
          name="twitter:description"
          content="Review Holypills Terms & Conditions to learn about user responsibilities, platform usage, and service guidelines."
        />

        <meta name="twitter:url" content="https://holypills.in/terms"></meta>
      </Helmet>
      <Header />
      <div className="wrapper_terms_policy">
        <div className="container">
          <div className="custom_container">
            <div className="privacy_policy_title">
              <h1>Terms & Conditions</h1>
            </div>
            <p
              dangerouslySetInnerHTML={{
                __html: terms.data,
              }}
            ></p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Terms;
